import React from "react";

export function PageHeader({ title, description, children }) {
  return (
    <header className="page-header">
      <div>
        <p className="eyebrow">SERVER MANAGEMENT</p>
        <h1>{title}</h1>
        {description && <p className="page-description">{description}</p>}
      </div>
      {children}
    </header>
  );
}

export function Panel({ title, description, children, className = "", open, onToggle, id, aside }) {
  const collapsible = Boolean(onToggle);
  return (
    <section className={`panel ${className}`}>
      {collapsible ? (
        <h2 className="panel-heading">
          <button className="panel-toggle" onClick={onToggle} aria-expanded={open} aria-controls={id}>
            <span>{title}</span>
            <span className="panel-chevron" aria-hidden="true">{open ? "−" : "+"}</span>
          </button>
        </h2>
      ) : (
        <div className="panel-header">
          <div>
            <h2>{title}</h2>
            {description && <p className="panel-description">{description}</p>}
          </div>
          {aside}
        </div>
      )}
      {(!collapsible || open) && <div className="panel-body" id={id}>{children}</div>}
    </section>
  );
}

export function Field({ label, htmlFor, hint, children }) {
  return (
    <div className="field">
      <label htmlFor={htmlFor}>{label}</label>
      {children}
      {hint && <span className="field-hint">{hint}</span>}
    </div>
  );
}
